import { Localizable } from '@components/localizable/Localizable'
import { Program } from '@models/membership/Program'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { ColorPicker } from '@supplement-bacon/react-toolkit/components'
import { SBRMFormActionProps, useSBRMForm } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { requiredRule } from '@utils/rules'
import { Form } from 'antd'
import { useCallback, useEffect } from 'react'
import SBIonIcon from '../SBIonIcon'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  const { metadata, getMetadata } = useSBRMForm()

  const programId = useCallback(() => {
    return getMetadata(MetadataKey.Program)
  }, [metadata, getMetadata])

  useEffect(() => {
    if (programId() !== undefined) {
      form.setFieldsValue({
        programs: [programId()],
      })
    }
  }, [programId()])

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Localizable.Input name="name" label="Name" rules={[requiredRule()]} />

      <Form.Item name="icon" label="Icon">
        <SBIonIcon.Picker />
      </Form.Item>

      <Form.Item name="color" label="Color">
        <ColorPicker />
      </Form.Item>

      <Form.Item name="programs" label={'Programs'} rules={[requiredRule()]}>
        <SBAsyncSelect<Program>
          entity={Entity.membershipProgram}
          multiple
          allowClear
        />
      </Form.Item>
    </Form>
  )
}

export default Create
